import * as Sentry from "@sentry/browser";

import { debug } from "./debug";

const LOGGER_ENABLED = !!(window && window.location.hostname === "localhost");

const levels = ["debug", "info", "warn", "error", "fatal"] as const;

export type Logger = Record<
	(typeof levels)[number],
	(message: string, attributes?: Record<string, unknown>) => void
>;

export const logger = Object.fromEntries(
	levels.map((level) => [
		level,
		(...args: Parameters<Logger[keyof Logger]>) => {
			return void (LOGGER_ENABLED
				? debug(level, ...args)
				: Sentry.logger[level](...args));
		},
	]),
) as Logger;
